import styled from "styled-components";
import IconButton from "../IconButton";

export const ToggleButton = styled(IconButton)`
  svg {
    width: 18px;
    height: 18px;
  }
`;
